import React from "react";
import { Event } from "types";
import { useAirbnbMessagingPlugin } from "../../hooks/usePlugins";
import { useResource } from "../../hooks/useResource";
import { MessageDrawer } from "../Common/MessageModal/MessageDrawer";
import { Loader } from "../Loader";
import { EventSummaryTile } from "./EventSummaryTile";

interface MessageEventModalProps {
    eventId?: ID;
    onClose: (e: any) => void;
    isOpen: boolean;
}

export const MessageEventModal = ({ eventId, onClose, isOpen }: MessageEventModalProps) => {
    const { data: event, isLoading } = useResource<Event>(["events", eventId], null, {
        enabled: isOpen,
    });
    const airbnbPlugin = useAirbnbMessagingPlugin();

    return (
        <MessageDrawer
            title="Send Group Message"
            filters={{ event: eventId }}
            isOpen={isOpen}
            description="This message will be sent to all attendees for this event."
            channels={{ messagingPlugin: airbnbPlugin ?? undefined }}
            onClose={onClose}
        >
            {isLoading ? <Loader /> : event ? <EventSummaryTile event={event} /> : null}
        </MessageDrawer>
    );
};
